module.exports = __webpack_public_path__ + "static/img/reChangJing5.7f58078.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reChangJing5.png
// module id = VCSZ
// module chunks = 2